angular.module('zc.zenclerkS')
  .controller('ZcsSetupPricingController', ZcsSetupPricingController);

ZcsSetupPricingController.$inject = ['$rootScope', 'Project', 'currencies', 'project'];
function ZcsSetupPricingController($rootScope, Project, currencies, project) {
  const vm = this;

  vm.project = project;
  vm.currency = currencies[vm.project.currency];

  if(vm.project.campaign_status === 'completed') {
    vm.project.pricing_confirmation_1 = vm.project.pricing_confirmation_2 = true;
  }

  vm.save = () => {
    vm.project.pricing_confirmed = true;
    vm.project.campaign_status = 'completed';
    // do not update for nothing
    if(!vm.project.pricing_confirmed_at) {
      Project.update({ projectId: `apikey:${vm.project.apikey}` }, { project: vm.project })
        .then(result => {
          vm.project = _.merge(vm.project, result);
          $rootScope.$broadcast('siteSetup.nextStep');
        });
    } else {
      $rootScope.$broadcast('siteSetup.nextStep');
    }
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/setup/setup_pricing.controller.js